import React from 'react';
import { useParams } from 'react-router-dom';
import RevelationIframe from './RevelationIframe';

const LegacyUserInfoPage: React.FC = () => {
    const { userId } = useParams();
    return (
        <RevelationIframe url={'/contacts/contactinfo.aspx?contact_id=' + userId} />);

}

export default LegacyUserInfoPage